import React, {useMemo} from 'react';
import {useProjectFormMailReportsByCategoryQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';

export default () => {
  const {projectId} = useParams<{projectId: string}>();
  const {data: {projectFormMailReportsByCategory = []} = {}} =
    useProjectFormMailReportsByCategoryQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectFormMailReportsByCategory.map((report) => {
        return {
          name: report.categoryName,
          mailCount: report.mailCount,
          clickCount: report.clickCount,
          clickRate: report.clickRate,
          replyCount: report.replyCount,
          replyRate: report.replyRate,
          appointCount: report.appointCount,
          appointRate: report.appointRate,
        };
      }),
    [projectFormMailReportsByCategory],
  );

  return <Table data={data} />;
};
